module.exports = __webpack_public_path__ + "static/img/bim13.7547225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/bim13.png
// module id = CLE5
// module chunks = 17